import { Controller } from "@hotwired/stimulus"

// Handles compliance check toggle interactions
export default class extends Controller {
  static values = { portfolioId: Number }
  static targets = ["checkbox", "counter", "header", "checkmark"]

  toggle(event) {
    event.stopPropagation() // Prevent event from bubbling up and causing scroll

    const checkbox = event.target
    checkbox.blur() // Remove focus to prevent scroll jump

    const checkId = checkbox.dataset.id
    const checked = checkbox.checked

    // Optimistic UI update
    const label = checkbox.closest("label")
    const textSpan = label.querySelector("span:last-child")
    if (checked) {
      textSpan.classList.add("text-[var(--color-kova-muted)]", "line-through")
    } else {
      textSpan.classList.remove("text-[var(--color-kova-muted)]", "line-through")
    }

    // Update counter and completion state
    this.updateCounter()
    this.updateCompletionState()

    // Save to server
    this.saveComplianceStatus(checkId, checked)
  }

  markAll(event) {
    event.stopPropagation()

    this.checkboxTargets.forEach(checkbox => {
      if (!checkbox.checked) {
        checkbox.checked = true
        const label = checkbox.closest("label")
        const textSpan = label.querySelector("span:last-child")
        textSpan.classList.add("text-[var(--color-kova-muted)]", "line-through")

        this.saveComplianceStatus(checkbox.dataset.id, true)
      }
    })

    this.updateCounter()
    this.updateCompletionState()

    // Hide the "Mark all complete" button
    const markAllButton = this.element.querySelector('[data-action="compliance-checks#markAll"]')
    if (markAllButton) {
      markAllButton.remove()
    }
  }

  updateCounter() {
    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter(cb => cb.checked).length

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `(${checked}/${total})`
    }
  }

  updateCompletionState() {
    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter(cb => cb.checked).length
    const allComplete = checked === total

    // Update header color
    if (this.hasHeaderTarget) {
      if (allComplete) {
        this.headerTarget.classList.remove("text-white")
        this.headerTarget.classList.add("text-green-400")
      } else {
        this.headerTarget.classList.remove("text-green-400")
        this.headerTarget.classList.add("text-white")
      }
    }

    // Show/hide checkmark
    if (this.hasCheckmarkTarget) {
      this.checkmarkTarget.classList.toggle("hidden", !allComplete)
    }

    // Collapse if all complete (use expandable controller)
    if (allComplete) {
      const expandableController = this.application.getControllerForElementAndIdentifier(
        this.element,
        "expandable"
      )
      if (expandableController) {
        expandableController.close()
      }
    }
  }

  async saveComplianceStatus(checkId, checked) {
    const response = await fetch(`/app/compliance_checks/${this.portfolioIdValue}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ check_id: checkId, checked: checked })
    })

    if (!response.ok) {
      console.error("Failed to save compliance status")
    }
  }
}

